import { render } from "./NewsView.vue?vue&type=template&id=59e26d4c&scoped=true&ts=true"
import script from "./NewsView.vue?vue&type=script&lang=ts"
export * from "./NewsView.vue?vue&type=script&lang=ts"

import "./NewsView.vue?vue&type=style&index=0&id=59e26d4c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e26d4c"]])

export default __exports__